module.exports = __webpack_public_path__ + "static/media/617AFly6phL._SL1200_.6df053ad.jpg";